import type { IAttachmentChange, IAttachmentState } from './attachmentChanges.types';

export function attachmentChangesDiff(
    previous: IAttachmentState,
    next: IAttachmentState,
    isOwn: (id?: string) => boolean,
): IAttachmentChange[] {
    if (previous.documentId !== next.documentId || previous.accessScopeToken !== next.accessScopeToken) return [];
    const before = new Map(previous.items.map((item) => [item.logicalFileId, item]));
    return next.items.flatMap((item): IAttachmentChange[] => {
        const old = before.get(item.logicalFileId);
        if (old?.contentChangeId === item.contentChangeId || isOwn(item.originOperationId)) return [];
        return [{ kind: old ? 'updated' : 'added', item }];
    });
}
